export default __webpack_public_path__ + "ibu_letter_footer.15336cf.jpg";